/* eslint-disable no-eval */
import { NivelAlgoritmoEnum, TipoAlgoritmoEnum } from "../../../../../enums";

type Props = {
  nivel: number;
  tipoAlgoritmo: number;
  expressao: string[];
  listagemDeVariaveis: number[];
};

export function GerarResultado({
  nivel,
  tipoAlgoritmo,
  expressao,
  listagemDeVariaveis,
}: Props) {
  if (TipoAlgoritmoEnum.CALCULOS === tipoAlgoritmo) {
    let expressaoString = expressao[0]?.split(" ");
    if (NivelAlgoritmoEnum.FACIL === nivel) {
      let convCalcFacil = [];
      for (let i = 0; i < expressaoString.length; i++) {
        switch (expressaoString[i]) {
          case "numero1":
            convCalcFacil.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            convCalcFacil.push(listagemDeVariaveis[1]);
            break;
          case "valor":
            convCalcFacil.push(listagemDeVariaveis[2]);
            break;
          case "+":
            convCalcFacil.push("+");
            break;
          case "-":
            convCalcFacil.push("-");
            break;
        }
      }
      const montagemFacil = `${convCalcFacil[0]} ${convCalcFacil[1]} ${convCalcFacil[2]} ${convCalcFacil[3]} ${convCalcFacil[4]}`;
      return eval(montagemFacil);
    }
    if (NivelAlgoritmoEnum.MEDIO === nivel) {
      let convCalcMedio = [];
      for (let i = 0; i < expressaoString.length; i++) {
        switch (expressaoString[i]) {
          case "numero1":
            convCalcMedio.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            convCalcMedio.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            convCalcMedio.push(listagemDeVariaveis[2]);
            break;
          case "valor":
            convCalcMedio.push(listagemDeVariaveis[3]);
            break;
          case "+":
            convCalcMedio.push("+");
            break;
          case "-":
            convCalcMedio.push("-");
            break;
        }
      }
      const montagemMedio = `${convCalcMedio[0]} ${convCalcMedio[1]} ${convCalcMedio[2]} ${convCalcMedio[3]} ${convCalcMedio[4]} ${convCalcMedio[5]} ${convCalcMedio[6]}`;
      return eval(montagemMedio);
    }
    if (NivelAlgoritmoEnum.DIFICIL === nivel) {
      let convCalcDificil = [];
      for (let i = 0; i < expressaoString.length; i++) {
        switch (expressaoString[i]) {
          case "numero1":
            convCalcDificil.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            convCalcDificil.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            convCalcDificil.push(listagemDeVariaveis[2]);
            break;
          case "numero4":
            convCalcDificil.push(listagemDeVariaveis[3]);
            break;
          case "valor":
            convCalcDificil.push(listagemDeVariaveis[4]);
            break;
          case "+":
            convCalcDificil.push("+");
            break;
          case "-":
            convCalcDificil.push("-");
            break;
          case "*":
            convCalcDificil.push("*");
            break;
        }
      }
      const montagemDificil = `${convCalcDificil[0]} ${convCalcDificil[1]} ${convCalcDificil[2]} ${convCalcDificil[3]} ${convCalcDificil[4]} ${convCalcDificil[5]} ${convCalcDificil[6]} ${convCalcDificil[7]} ${convCalcDificil[8]}`;
      return eval(montagemDificil);
    }
  }

  if (TipoAlgoritmoEnum.CONDICIONAIS === tipoAlgoritmo) {
    let expressao1 = expressao[0]?.split(" ");
    let expressao2 = expressao[1]?.split(" ");
    let expressao3 = expressao[2]?.split(" ");
    // CONDICIONAL FACIL
    if (NivelAlgoritmoEnum.FACIL === nivel) {
      let montarExpressao1 = [];
      let montarExpressao2 = [];
      let montarExpressao3 = [];
      for (let i = 0; i < expressao1.length; i++) {
        switch (expressao1[i]) {
          case "numero1":
            montarExpressao1.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao1.push(listagemDeVariaveis[1]);
            break;
          case "valor":
            montarExpressao1.push(listagemDeVariaveis[2]);
            break;
          case ">":
            montarExpressao1.push(">");
            break;
          case "<":
            montarExpressao1.push("<");
            break;
        }
      }
      for (let i = 0; i < expressao2.length; i++) {
        switch (expressao2[i]) {
          case "numero1":
            montarExpressao2.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao2.push(listagemDeVariaveis[1]);
            break;
          case "valor":
            montarExpressao2.push(listagemDeVariaveis[2]);
            break;
          case "+":
            montarExpressao2.push("+");
            break;
          case "-":
            montarExpressao2.push("-");
            break;
        }
      }
      for (let i = 0; i < expressao3.length; i++) {
        switch (expressao3[i]) {
          case "numero1":
            montarExpressao3.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao3.push(listagemDeVariaveis[1]);
            break;
          case "valor":
            montarExpressao3.push(listagemDeVariaveis[2]);
            break;
          case "+":
            montarExpressao3.push("+");
            break;
          case "-":
            montarExpressao3.push("-");
            break;
        }
      }
      const montagemExp1 = `${montarExpressao1[0]} ${montarExpressao1[1]} ${montarExpressao1[2]}`;
      const montagemExp2 = `${montarExpressao2[0]} ${montarExpressao2[1]} ${montarExpressao2[2]} ${montarExpressao2[3]} ${montarExpressao2[4]}`;
      const montagemExp3 = `${montarExpressao3[0]} ${montarExpressao3[1]} ${montarExpressao3[2]} ${montarExpressao3[3]} ${montarExpressao3[4]}`;
      if (eval(montagemExp1)) {
        return eval(montagemExp2);
      } else {
        return eval(montagemExp3);
      }
    }
    // CONDICIONAL MEDIO
    if (NivelAlgoritmoEnum.MEDIO === nivel) {
      let montarExpressao1 = [];
      let montarExpressao2 = [];
      let montarExpressao3 = [];
      for (let i = 0; i < expressao1.length; i++) {
        switch (expressao1[i]) {
          case "numero1":
            montarExpressao1.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao1.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressao1.push(listagemDeVariaveis[2]);
            break;
          case "valor":
            montarExpressao1.push(listagemDeVariaveis[3]);
            break;
          case ">":
            montarExpressao1.push(">");
            break;
          case "<":
            montarExpressao1.push("<");
            break;
        }
      }
      for (let i = 0; i < expressao2.length; i++) {
        switch (expressao2[i]) {
          case "numero1":
            montarExpressao2.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao2.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressao2.push(listagemDeVariaveis[2]);
            break;
          case "valor":
            montarExpressao2.push(listagemDeVariaveis[3]);
            break;
          case "+":
            montarExpressao2.push("+");
            break;
          case "-":
            montarExpressao2.push("-");
            break;
        }
      }
      for (let i = 0; i < expressao3.length; i++) {
        switch (expressao3[i]) {
          case "numero1":
            montarExpressao3.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao3.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressao3.push(listagemDeVariaveis[2]);
            break;
          case "valor":
            montarExpressao3.push(listagemDeVariaveis[3]);
            break;
          case "+":
            montarExpressao3.push("+");
            break;
          case "-":
            montarExpressao3.push("-");
            break;
        }
      }
      const montagemExp1 = `${montarExpressao1[0]} ${montarExpressao1[1]} ${montarExpressao1[2]}`;
      const montagemExp2 = `${montarExpressao2[0]} ${montarExpressao2[1]} ${montarExpressao2[2]} ${montarExpressao2[3]} ${montarExpressao2[4]} ${montarExpressao2[5]} ${montarExpressao2[6]}`;
      const montagemExp3 = `${montarExpressao3[0]} ${montarExpressao3[1]} ${montarExpressao3[2]} ${montarExpressao3[3]} ${montarExpressao3[4]} ${montarExpressao3[5]} ${montarExpressao3[6]}`;

      if (eval(montagemExp1)) {
        return eval(montagemExp2);
      } else {
        return eval(montagemExp3);
      }
    }
    // CONDICIONAL DIFICIL
    if (NivelAlgoritmoEnum.DIFICIL === nivel) {
      let montarExpressao1 = [];
      let montarExpressao2 = [];
      let montarExpressao3 = [];
      for (let i = 0; i < expressao1.length; i++) {
        switch (expressao1[i]) {
          case "numero1":
            montarExpressao1.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao1.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressao1.push(listagemDeVariaveis[2]);
            break;
          case "numero4":
            montarExpressao1.push(listagemDeVariaveis[3]);
            break;
          case "valor":
            montarExpressao1.push(listagemDeVariaveis[4]);
            break;
          case ">":
            montarExpressao1.push(">");
            break;
          case "<":
            montarExpressao1.push("<");
            break;
        }
      }
      for (let i = 0; i < expressao2.length; i++) {
        switch (expressao2[i]) {
          case "numero1":
            montarExpressao2.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao2.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressao2.push(listagemDeVariaveis[2]);
            break;
          case "numero4":
            montarExpressao2.push(listagemDeVariaveis[3]);
            break;
          case "valor":
            montarExpressao2.push(listagemDeVariaveis[4]);
            break;
          case "+":
            montarExpressao2.push("+");
            break;
          case "-":
            montarExpressao2.push("-");
            break;
          case "*":
            montarExpressao2.push("*");
            break;
        }
      }
      for (let i = 0; i < expressao3.length; i++) {
        switch (expressao3[i]) {
          case "numero1":
            montarExpressao3.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressao3.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressao3.push(listagemDeVariaveis[2]);
            break;
          case "numero4":
            montarExpressao3.push(listagemDeVariaveis[3]);
            break;
          case "valor":
            montarExpressao3.push(listagemDeVariaveis[4]);
            break;
          case "+":
            montarExpressao3.push("+");
            break;
          case "-":
            montarExpressao3.push("-");
            break;
          case "*":
            montarExpressao3.push("*");
            break;
        }
      }
      const montagemExp1 = `${montarExpressao1[0]} ${montarExpressao1[1]} ${montarExpressao1[2]}`;
      const montagemExp2 = `${montarExpressao2[0]} ${montarExpressao2[1]} ${montarExpressao2[2]} ${montarExpressao2[3]} ${montarExpressao2[4]} ${montarExpressao2[5]} ${montarExpressao2[6]} ${montarExpressao2[7]} ${montarExpressao2[8]}`;
      const montagemExp3 = `${montarExpressao3[0]} ${montarExpressao3[1]} ${montarExpressao3[2]} ${montarExpressao3[3]} ${montarExpressao3[4]} ${montarExpressao3[5]} ${montarExpressao3[6]} ${montarExpressao3[7]} ${montarExpressao3[8]}`;

      if (eval(montagemExp1)) {
        return eval(montagemExp2);
      } else {
        return eval(montagemExp3);
      }
    }
  } else {
    let expressao2 = expressao[1]?.split(" ");
    let expressao3 = expressao[2]?.split(" ");
    // REPETICOES FACIL
    if (NivelAlgoritmoEnum.FACIL === nivel) {
      let montarExpressaoRepeticoes = [];
      let valor = [];
      for (let i = 0; i < expressao2.length; i++) {
        switch (expressao2[i]) {
          case "numero1":
            montarExpressaoRepeticoes.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressaoRepeticoes.push(listagemDeVariaveis[1]);
            break;
          case "+":
            montarExpressaoRepeticoes.push("+");
            break;
        }
      }
      for (let i = 0; i < expressao3.length; i++) {
        switch (expressao3[i]) {
          case "valor":
            valor.push(Number(listagemDeVariaveis[2]));
            break;
        }
      }
      const montagemExpresRepet = `${montarExpressaoRepeticoes[0]} ${montarExpressaoRepeticoes[1]} ${montarExpressaoRepeticoes[2]}`;

      // Calculando valor de resultado final
      for (let i = 0; i < valor[0]; ) {
        i = i + Number(eval(montagemExpresRepet));
        if (i > valor[0]) return i;
      }
    }
    // REPETICOES MEDIO
    if (NivelAlgoritmoEnum.MEDIO === nivel) {
      let montarExpressaoRepeticoesMed = [];
      let valor = [];
      for (let i = 0; i < expressao2.length; i++) {
        switch (expressao2[i]) {
          case "numero1":
            montarExpressaoRepeticoesMed.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressaoRepeticoesMed.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressaoRepeticoesMed.push(listagemDeVariaveis[2]);
            break;
          case "+":
            montarExpressaoRepeticoesMed.push("+");
            break;
        }
      }
      for (let i = 0; i < expressao3.length; i++) {
        switch (expressao3[i]) {
          case "valor":
            valor.push(Number(listagemDeVariaveis[3]));
            break;
        }
      }
      const montagemExpresRepet = `${montarExpressaoRepeticoesMed[0]} ${montarExpressaoRepeticoesMed[1]} ${montarExpressaoRepeticoesMed[2]} ${montarExpressaoRepeticoesMed[3]} ${montarExpressaoRepeticoesMed[4]}`;

      // Calculando valor de resultado final
      for (let i = 0; i < valor[0]; ) {
        i = i + Number(eval(montagemExpresRepet));
        if (i > valor[0]) return i;
      }
    }
    // REPETICOES DIFICIL
    if (NivelAlgoritmoEnum.DIFICIL === nivel) {
      let montarExpressaoRepeticoesDif = [];
      let valor = [];
      for (let i = 0; i < expressao2.length; i++) {
        switch (expressao2[i]) {
          case "numero1":
            montarExpressaoRepeticoesDif.push(listagemDeVariaveis[0]);
            break;
          case "numero2":
            montarExpressaoRepeticoesDif.push(listagemDeVariaveis[1]);
            break;
          case "numero3":
            montarExpressaoRepeticoesDif.push(listagemDeVariaveis[2]);
            break;
          case "+":
            montarExpressaoRepeticoesDif.push("+");
            break;
          case "*":
            montarExpressaoRepeticoesDif.push("*");
            break;
        }
      }
      for (let i = 0; i < expressao3.length; i++) {
        switch (expressao3[i]) {
          case "valor":
            valor.push(Number(listagemDeVariaveis[3]));
            break;
        }
      }
      const montagemExpresRepet = `${montarExpressaoRepeticoesDif[0]} ${montarExpressaoRepeticoesDif[1]} ${montarExpressaoRepeticoesDif[2]} ${montarExpressaoRepeticoesDif[3]} ${montarExpressaoRepeticoesDif[4]}`;

      // Calculando valor de resultado final
      for (let i = 0; i < valor[0]; ) {
        i = i + Number(eval(montagemExpresRepet));
        if (i > valor[0]) return i;
      }
    }
  }
}
